/* =========================================================
   CUSTOM JAVASCRIPT
   ========================================================= */

/* CUSTOM START: Announcement bar height */
const setAnnouncementBarHeight = () => {
  const announcementBar = document.querySelector('.announcement-bar-section');
  const height = announcementBar ? announcementBar.offsetHeight : 0;

  document.documentElement.style.setProperty(
    '--announcement-bar-height',
    `${height}px`
  );
};

setAnnouncementBarHeight();

const announcementBar = document.querySelector('.announcement-bar-section');

if (announcementBar) {
  const announcementBarObserver = new ResizeObserver(setAnnouncementBarHeight);
  announcementBarObserver.observe(announcementBar);
}

window.addEventListener('resize', setAnnouncementBarHeight);
/* CUSTOM END: Announcement bar height */


/* CUSTOM START: LP Product gallery */
document.querySelectorAll('[data-lp-product-gallery]').forEach((gallery) => {
const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
const prevButton = gallery.querySelector('[data-gallery-prev]');
const nextButton = gallery.querySelector('[data-gallery-next]');

if (!slides.length) return;

let currentIndex = 0;

const showSlide = (index) => {
currentIndex = index;

slides.forEach((slide, slideIndex) => {
  slide.classList.toggle('is-active', slideIndex === currentIndex);
});

thumbnails.forEach((thumbnail, thumbnailIndex) => {
  thumbnail.classList.toggle('is-active', thumbnailIndex === currentIndex);
});

};

thumbnails.forEach((thumbnail, index) => {
thumbnail.addEventListener('click', () => {
showSlide(index);
});
});

if (prevButton) {
prevButton.addEventListener('click', () => {
const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
showSlide(prevIndex);
});
}

if (nextButton) {
nextButton.addEventListener('click', () => {
const nextIndex = (currentIndex + 1) % slides.length;
showSlide(nextIndex);
});
}

showSlide(0);
});
/* CUSTOM END: LP Product gallery */

/* CUSTOM START: Sticky product bar */
document.querySelectorAll('[data-lp-product-gallery]').forEach((gallery) => {
  const sourceBar = gallery.querySelector('[data-sticky-product-source]');
  const fixedBar = gallery.querySelector('[data-sticky-product-fixed]');
  const quantitySelects = gallery.querySelectorAll('[data-sticky-quantity]');

  if (!sourceBar || !fixedBar) return;

  const updateStickyProductBar = () => {
    const sourceRect = sourceBar.getBoundingClientRect();
    fixedBar.classList.toggle('is-visible', sourceRect.bottom <= 0);
  };

  quantitySelects.forEach((select) => {
    select.addEventListener('change', () => {
      quantitySelects.forEach((otherSelect) => {
        if (otherSelect !== select) {
          otherSelect.value = select.value;
        }
      });
    });
  });

  updateStickyProductBar();

  window.addEventListener('scroll', updateStickyProductBar, { passive: true });
  window.addEventListener('resize', updateStickyProductBar);
});
/* CUSTOM END: Sticky product bar */

/* CUSTOM START: Shipping policy title */
if (window.location.pathname === '/policies/shipping-policy') {
  const policyTitle = document.querySelector('.shopify-policy__title h1');

  if (policyTitle) {
    policyTitle.textContent = 'SHIPPING POLICY';
  }
}
/* CUSTOM END: Shipping policy title */

/////////////////////////////////////
// サンクスページ
/////////////////////////////////////
(() => {
  const THANKS_URL = "/pages/maison-privee-thanks";
  const FLAG_KEY = "maison_privee_register_just_submitted";

  const isThanksPage = () => location.pathname === THANKS_URL;
  const isAccountPage = () =>
    location.pathname === "/account" || location.pathname === "/account/";
  const isRegisterPage = () => location.pathname === "/account/register";

  const markJustSubmitted = () => {
    try {
      sessionStorage.setItem(FLAG_KEY, "1");
    } catch (e) {}
  };

  const clearFlag = () => {
    try {
      sessionStorage.removeItem(FLAG_KEY);
    } catch (e) {}
  };

  const hasFlag = () => {
    try {
      return sessionStorage.getItem(FLAG_KEY) === "1";
    } catch (e) {
      return false;
    }
  };

  const registerForm = document.querySelector("#create-customer form");
  if (registerForm) {
    registerForm.addEventListener("submit", () => {
      markJustSubmitted();
    });
  }

  // 登録失敗（既登録メール等）で /account/register に戻ってきた場合はフラグをクリア
  if (isRegisterPage() && hasFlag()) {
    clearFlag();
    return;
  }

  if (isAccountPage() && hasFlag()) {
    clearFlag();
    location.replace('/account/register?error=already_registered');
    return;
  }

  if (isThanksPage()) {
    clearFlag();
  }
  })();


